import script from "./AimCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AimCard.vue?vue&type=script&setup=true&lang=js"

import "./AimCard.vue?vue&type=style&index=0&id=00017d3f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00017d3f"]])

export default __exports__